import { apiClient, FileInfo } from '@melio/javascript-sdk';

import { useCollectionApi, UseCollectionApiProps } from '../../core';
import { useCreateMutation } from '../../core/useCreateMutation';
import { FileCollection } from './types';

type UseFilesProps = UseCollectionApiProps<FileInfo>;

export const useFiles = (props: UseFilesProps = {}): FileCollection => {
  const client = apiClient.files();
  const query = useCollectionApi<FileInfo, File>({
    ...props,
    queryKey: 'file',
    queryFn: client.fetch,
  });

  const create = useCreateMutation<FileInfo, File>(client.upload, query);

  return {
    ...query,
    create,
  };
};
